import { isSSR } from 'src/helpers/ssr';

const GHC_USER_AGENT_MARKER = 'google-hoteladsverifier';
export const isGhcBot = (): boolean => {
  if (isSSR) return false;

  const userAgent = window.navigator?.userAgent ?? '';
  const isGhcUserAgent = userAgent
    .toLowerCase()
    .includes(GHC_USER_AGENT_MARKER);

  return isGhcUserAgent;
};
